import { api } from './api';
import { BroadcastPayload, BroadcastResponse } from '../types/Notification';

/**
 * Sends a bulk notification to the specified user target.
 * Endpoint: POST /admin/notifications/send
 */
export const sendBroadcastNotification = (payload: BroadcastPayload) => {
    return api.post<BroadcastResponse>('/admin/notifications/send', payload);
};